import { createFileRoute } from "@tanstack/react-router"
import { ArrowRight } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { IconButton } from "@/components/ui/iconbutton"

export const Route = createFileRoute("/design/button-disabled-showcase")({
  component: ButtonDisabledShowcase,
})

function ButtonDisabledShowcase() {
  return (
    <div className="container mx-auto space-y-8 p-8">
      <h1 className="mb-8 text-3xl font-bold">Button Disabled State Showcase</h1>

      <Card>
        <CardHeader>
          <CardTitle>Disabled Button States</CardTitle>
          <CardDescription>Implementation of the disabled button design from Figma</CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Primary Variant */}
          <div className="space-y-2">
            <h3 className="text-muted-foreground text-sm font-medium">Primary Variant</h3>
            <div className="flex gap-4">
              <Button variant="default">Enabled</Button>
              <Button variant="default" disabled>
                Disabled
              </Button>
            </div>
          </div>

          {/* Secondary Variant (matching Figma design) */}
          <div className="space-y-2">
            <h3 className="text-muted-foreground text-sm font-medium">
              Secondary Variant (Figma Design)
            </h3>
            <div className="flex gap-4">
              <Button variant="secondary">Enabled</Button>
              <Button variant="secondary" disabled>
                Disabled
              </Button>
            </div>
            <p className="text-muted-foreground text-xs">
              Background: #dadfe3 (neutral/150), Border: #8593a3 (neutral/500), Text: #505862
              (neutral/700)
            </p>
          </div>

          {/* With Icons */}
          <div className="space-y-2">
            <h3 className="text-muted-foreground text-sm font-medium">With Icons</h3>
            <div className="flex gap-4">
              <IconButton
                variant="secondary"
                icon={<ArrowRight className="size-4" />}
                label="Enabled"
              >
                Enabled
              </IconButton>
              <IconButton
                variant="secondary"
                icon={<ArrowRight className="size-4" />}
                label="Disabled"
                disabled
              >
                Disabled
              </IconButton>
            </div>
          </div>

          {/* Other Variants */}
          <div className="space-y-2">
            <h3 className="text-muted-foreground text-sm font-medium">Other Variants</h3>
            <div className="space-y-2">
              <div className="flex gap-4">
                <Button variant="ghost">Ghost Enabled</Button>
                <Button variant="ghost" disabled>
                  Ghost Disabled
                </Button>
              </div>
              <div className="flex gap-4 rounded bg-neutral-900 p-4">
                <Button variant="ghost">Ghost Inverted Enabled</Button>
                <Button variant="ghost" disabled>
                  Ghost Inverted Disabled
                </Button>
              </div>
            </div>
          </div>

          {/* Backward Compatibility */}
          <div className="space-y-2">
            <h3 className="text-muted-foreground text-sm font-medium">Backward Compatibility</h3>
            <div className="flex gap-4">
              <Button variant="outline">Outline (alias for secondary)</Button>
              <Button variant="outline" disabled>
                Outline Disabled
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
